import {
  Button,
  FormControl,
  IconButton,
  MenuItem,
  Select,
  Theme,
  makeStyles
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import React, { useState } from 'react';
import { DEFAULT_LIQUID } from 'src/constants/defaultLiquid';
import { RootState, useDispatch, useSelector } from 'src/store';
import { editText } from 'src/store/modules/editText';

const useStyles = makeStyles((theme: Theme) => ({
  selectEmpty: {
    marginTop: theme.spacing(2)
  },
  input: {
    width: '500px',
    marginLeft: '20px',
    padding: '10px',
    border: '1px solid #BEBEBE',
    borderRadius: '5px'
  }
}));

const AddLiquidModal = ({ type, setModaltype }) => {
  const classes = useStyles();
  const [liquid, setLiquid] = useState('');
  const [defaultValue, setDefaultValue] = useState('');
  const [includeLiquidText, setIncludeLiquidText] = useState('');
  const [isClicked, setIsClicked] = useState(false);
  const text = useSelector((state: RootState) => state.editText.text);
  const currentIndex = useSelector(
    (state: RootState) => state.imageUpload.currentIndex
  );

  const dispatch = useDispatch();

  const onClickLiquid = (textType, liquid) => {
    setDefaultValue('');
    setLiquid(liquid);
    setIsClicked(true);
    if (type.includes('multi')) {
      const prevText = text?.[textType]?.[currentIndex];
      setIncludeLiquidText(prevText + liquid);
    } else {
      const prevText = text[textType];
      setIncludeLiquidText(prevText + liquid);
    }
  };

  const handleDefalutValue = e => {
    const textSplit = e.target.value.split('');
    if (
      textSplit[textSplit.length - 1] === '\\' ||
      textSplit[textSplit.length - 1] === '"' ||
      textSplit[textSplit.length - 1] === "'"
    )
      return;
    setDefaultValue(e.target.value);
  };

  const onClickAddLiquid = textType => {
    if (type.includes('multi')) {
      const prevText = text?.[textType]?.[currentIndex];
      const currentText = text?.[textType]?.slice();
      if (defaultValue === '') {
        currentText.splice(currentIndex, 1, includeLiquidText);
        const newText = JSON.parse(
          `{"${textType}": [${currentText?.map((_: any, idx: number) => {
            const newT = currentText?.[idx].split('\n').join('\\n');
            return `"${newT}"`;
          })}]}`
        );
        dispatch(editText({ ...text, ...newText }));
        setModaltype(null);
      } else {
        const DefaultLiquid = liquid.replace(/}}/g, '');
        const insertDefaultValue =
          `${prevText + DefaultLiquid} | default:` + `'${defaultValue}'` + '}}';
        currentText.splice(currentIndex, 1, insertDefaultValue);
        const newText = JSON.parse(
          `{"${textType}": [${currentText?.map((_: any, idx: number) => {
            const newT = currentText?.[idx].split('\n').join('\\n');
            return `"${newT}"`;
          })}]}`
        );
        dispatch(editText({ ...text, ...newText }));
        setModaltype(null);
      }
    } else {
      const prevText = text[textType];
      if (defaultValue === '') {
        const newText = JSON.parse(`{"${textType}": "${includeLiquidText}"}`);
        dispatch(editText({ ...text, ...newText }));
        setModaltype(null);
      } else {
        const DefaultLiquid = liquid.replace(/}}/g, '');
        const insertDefaultValue =
          `${prevText + DefaultLiquid} | default:` + `'${defaultValue}'` + '}}';
        const newText = JSON.parse(`{"${textType}": "${insertDefaultValue}"}`);
        dispatch(editText({ ...text, ...newText }));
        setModaltype(null);
      }
    }
  };
  return (
    <div
      style={{
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px',
        borderRadius: '10px'
      }}
    >
      <div
        style={{
          width: '680px',
          height: '250px',
          backgroundColor: 'white',
          padding: '28px 43px 33px 43px',
          display: 'flex',
          flexDirection: 'column',
          borderRadius: '10px'
        }}
      >
        <IconButton
          style={{
            position: 'absolute',
            right: '10px',
            top: '10px'
          }}
          onClick={() => setModaltype(null)}
        >
          <CloseIcon />
        </IconButton>
        <p style={{ fontSize: '22px', fontWeight: 700 }}>Liquid</p>
        <span
          style={{
            fontSize: '13px',
            fontWeight: 400,
            fontFamily: 'Inter',
            marginBottom: '20px'
          }}
        >
          Personalization Using Liquid Tags
          <a
            style={{ color: '#7A7A7A', marginLeft: '3px' }}
            href="https://metric-studio.notion.site/Liquid-38f3907dec7d42fcad0aa9a6ebc579b9?pvs=4"
            target="_blank"
            rel="noopener noreferrer"
          >
            Read more
          </a>
        </span>
        <div
          style={{
            display: 'flex',
            alignItems: 'center'
          }}
        >
          <span style={{ width: '50px', fontSize: '14px' }}>Type</span>
          <FormControl
            style={{
              width: '230px',
              marginLeft: '20px'
            }}
          >
            <Select
              displayEmpty
              MenuProps={{
                anchorOrigin: {
                  vertical: 'bottom',
                  horizontal: 'left'
                },
                transformOrigin: {
                  vertical: 'top',
                  horizontal: 'left'
                },
                PaperProps: {
                  style: {
                    maxHeight: '200px'
                  }
                },
                getContentAnchorEl: null,
                disableScrollLock: true
              }}
              style={{ margin: 0, fontSize: '14px' }}
            >
              <MenuItem style={{ fontSize: '13px' }}>
                Default Attribute
              </MenuItem>
            </Select>
          </FormControl>

          <FormControl
            style={{
              width: '260px',
              marginLeft: '10px'
            }}
          >
            <Select
              displayEmpty
              className={classes.selectEmpty}
              inputProps={{
                'aria-label': 'Without label'
              }}
              MenuProps={{
                anchorOrigin: {
                  vertical: 'bottom',
                  horizontal: 'left'
                },
                transformOrigin: {
                  vertical: 'top',
                  horizontal: 'left'
                },
                PaperProps: {
                  style: {
                    maxHeight: '200px'
                  }
                },
                getContentAnchorEl: null,
                disableScrollLock: true
              }}
              style={{ margin: 0, fontSize: '14px' }}
            >
              <MenuItem
                style={{
                  color: 'gray',
                  fontSize: '12px',
                  paddingTop: '3px',
                  paddingBottom: '3px',
                  backgroundColor: 'transparent'
                }}
              >
                Seach for an attribute
              </MenuItem>
              {DEFAULT_LIQUID.map((liquid, idx) => (
                <MenuItem
                  key={idx}
                  value={liquid}
                  onClick={() => onClickLiquid(type, liquid)}
                  style={{ fontSize: '13px' }}
                >
                  {liquid}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        <div
          style={{ display: 'flex', marginTop: '10px', marginBottom: '10px' }}
        >
          <div style={{ width: '50px', fontSize: '14px' }}>Default Value</div>
          <input
            onChange={e => handleDefalutValue(e)}
            value={defaultValue}
            className={classes.input}
            placeholder="Enter default value(optional)"
            disabled={!isClicked}
          />
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'end',
            paddingRight: '20px'
          }}
        >
          <Button
            variant="contained"
            color="primary"
            size="medium"
            onClick={() => onClickAddLiquid(type)}
            disabled={!isClicked}
          >
            Insert
          </Button>
        </div>
      </div>
    </div>
  );
};
export default AddLiquidModal;
